// src/components/Admin/LogViewer.js
import React, { useState } from 'react';
import { Card, Table, Button, Badge, Form } from 'react-bootstrap';
import logger from '../../utils/logger';

const LogViewer = () => {
	const [logs, setLogs] = useState([]);
	const [filter, setFilter] = useState('all');

	const loadLogs = () => {
		const allLogs = logger.exportLogs();
		setLogs(allLogs);
	};

	const filteredLogs = logs.filter(log =>
		filter === 'all' || log.level === filter
	);

	const getLevelColor = (level) => {
		const colors = {
			error: 'danger',
			warn: 'warning',
			info: 'info',
			debug: 'secondary'
		};
		return colors[level] || 'secondary';
	};

	return (
		<Card>
			<Card.Header className="d-flex justify-content-between align-items-center">
				<h5>Frontend Logs</h5>
				<div>
					<Form.Select
						value={filter}
						onChange={(e) => setFilter(e.target.value)}
						className="me-2"
						style={{ background: "white", width: 'auto', display: 'inline-block' }}
					>
						<option value="all">All Levels</option>
						<option value="error">Errors Only</option>
						<option value="warn">Warnings Only</option>
						<option value="info">Info Only</option>
					</Form.Select>
					<Button onClick={loadLogs} variant="primary" size="sm">
						Refresh Logs
					</Button>
					<Button
						onClick={() => logger.clearLogs()}
						variant="outline-danger"
						size="sm"
						className="ms-2"
					>
						Clear
					</Button>
				</div>
			</Card.Header>
			<Card.Body style={{ background: "white", maxHeight: '600px', overflowY: 'auto' }}>
				<Table
					bordered
					hover
					size="sm"
					className="table-white"
					style={{ backgroundColor: 'white' }}>
					<thead>
						<tr>
							<th>Time</th>
							<th>Level</th>
							<th>Message</th>
							<th>Details</th>
						</tr>
					</thead>
					<tbody>
						{filteredLogs.length === 0 ? (
							<tr>
								<td colSpan="4" className="text-center">
									No logs available. Click "Refresh Logs" to load.
								</td>
							</tr>
						) : (
							filteredLogs.map((log, index) => (
								<tr key={index}>
									<td style={{ whiteSpace: 'nowrap' }}>
										{new Date(log.timestamp).toLocaleString()}
									</td>
									<td>
										<Badge bg={getLevelColor(log.level)}>
											{log.level.toUpperCase()}
										</Badge>
									</td>
									<td>{log.message}</td>
									<td>
										<code style={{ fontSize: '0.8rem' }}>
											{JSON.stringify(log.meta, null, 2)}
										</code>
									</td>
								</tr>
							))
						)}
					</tbody>
				</Table>
			</Card.Body>
		</Card>
	);
};

export default LogViewer;